import { render, staticRenderFns } from "./draggableTable.vue?vue&type=template&id=35786484&scoped=true"
import script from "./draggableTable.vue?vue&type=script&lang=js"
export * from "./draggableTable.vue?vue&type=script&lang=js"
import style0 from "./draggableTable.vue?vue&type=style&index=0&id=35786484&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35786484",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35786484')) {
      api.createRecord('35786484', component.options)
    } else {
      api.reload('35786484', component.options)
    }
    module.hot.accept("./draggableTable.vue?vue&type=template&id=35786484&scoped=true", function () {
      api.rerender('35786484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cont/draggableTable.vue"
export default component.exports